import React, {useState, useEffect, useCallback, useMemo} from 'react';
import './ArrDashedProgressBar.scss';
import {generateRandomNumber} from '../../../utils/utils';

interface ArrDashedProgressBarProps {
  totalSegments: number;
  color?: string;
  intervalTime?: number;
}

const ArrDashedProgressBar: React.FC<ArrDashedProgressBarProps> = ({
  totalSegments,
  color = '#6E87FF',
  intervalTime = 1000,
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) return 0;
        return prevProgress + 1;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [intervalTime]);

  const getColor = useCallback(
    (index: number) => {
      const colorIndex = Math.floor((progress / 100) * totalSegments);
      return index <= colorIndex ? color : '#263449';
    },
    [progress, totalSegments, color]
  );

  const segmentKeys = useMemo(
    () =>
      Array.from(
        {length: totalSegments},
        (_, i) => `dashed-${generateRandomNumber()}-${i}`
      ),
    [totalSegments]
  );

  return (
    <div
      className="arr-dashed-progress-bar-container"
      data-testid={`arr-dashed-progress-bar-div`}
    >
      {segmentKeys.map((key, index) => (
        <div
          key={key}
          className="arr-dashed-progress-segment"
          style={{
            backgroundColor: getColor(index),
            width: `${100 / totalSegments}%`,
          }}
          data-testid={`arr-dashed-progress-bar-segment-${index}`}
        />
      ))}
    </div>
  );
};

export {ArrDashedProgressBar};
